import PropTypes from 'prop-types';
import React from 'react';
import { components } from '@glowforge/ui-common';
import ChevronLeft from './chevron-left.svg';
import ChevronUp from './chevron-up.svg';

import './bottom-button.less';

const { Button } = components;

export default function BottomButton({
  label,
  next,
  prev,
  onClick,
  canGoBack,
}) {
  return (
    <div className='bottomButtonContainer'>
      <div className='navButtons'>
        {canGoBack && <Button onClick={() => onClick('')} className='clearButton secondaryButton'>
          <ChevronUp className='clearSvg' />Contents
        </Button>}
        {canGoBack && (
          <Button onClick={() => onClick(prev)} className='clearButton secondaryButton'>
            <ChevronLeft className='clearSvg' />Back
          </Button>
        )}
      </div>
      {next && (<Button onClick={() => onClick(next)} className='clearButton nextButton'>{label}</Button>)}
    </div>
  );
}

BottomButton.propTypes = {
  label: PropTypes.string,
  next: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  canGoBack: PropTypes.bool.isRequired,
  prev: PropTypes.string,
};

BottomButton.defaultProps = {
  label: null,
  next: null,
  prev: null,
};



// WEBPACK FOOTER //
// ./app/components/setup/bottom-button.jsx